import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import Styles from './TokensStatisticsCard.module.css'
import { Colors } from 'Theme'
import PropTypes from 'prop-types'
import { AnalyticsDataCard } from 'Components'
import AnalyticsSelectors from 'Stores/Analytics/Selectors'
import AnalyticsActions from 'Stores/Analytics/Actions'
import RequestState from 'Enums/RequestState'
import { formatNumber, getEnergyUnit } from 'Utils/Calculations'
import { useTranslation } from 'react-i18next'

const TokensStatisticsCard = ({
  tokensStatistics,
  fetchTokensStatistics,
  fetchTokensStatisticsRequestState,
  filter,
}) => {
  const { t } = useTranslation()

  useEffect(() => {
    fetchTokensStatistics(filter)
  }, [filter])

  const avg = tokensStatistics?.data?.avgConsumption ?? 0
  const max = tokensStatistics?.data?.maxConsumption ?? 0

  const { divisor: avgDivisor, unit: avgUnit } = getEnergyUnit(avg)
  const { divisor: maxDivisor, unit: maxUnit } = getEnergyUnit(max)

  return (
    <div
      style={{
        backgroundColor: Colors.white,
      }}
      className={Styles.Card}
    >
      <div className={Styles.Top}>
        <AnalyticsDataCard
          title={t('Analytics.TokensAdded')}
          subtitle={t(
            `Analytics.Since${filter[0].value
              .charAt(0)
              .toUpperCase()}${filter[0].value.slice(1)}`,
          )}
          percentage={tokensStatistics?.data?.percentageTokensAdded}
          primaryValue={formatNumber(tokensStatistics?.data?.tokensAdded)}
          body={` ${
            fetchTokensStatisticsRequestState === RequestState.LOADING ||
            fetchTokensStatisticsRequestState === RequestState.SUCCEEDED ||
            fetchTokensStatisticsRequestState == RequestState.UNINITIALIZED
              ? formatNumber(tokensStatistics?.data?.avgTokensPerDay)
              : '-'
          } ${t('Analytics.AverageTokens')}`}
          isLoading={fetchTokensStatisticsRequestState === RequestState.LOADING}
          showDash={
            !(
              fetchTokensStatisticsRequestState === RequestState.LOADING ||
              fetchTokensStatisticsRequestState === RequestState.SUCCEEDED ||
              fetchTokensStatisticsRequestState == RequestState.UNINITIALIZED
            )
          }
        />
        <AnalyticsDataCard
          title={t('Analytics.TokensConsumption')}
          subtitle={t(
            `Analytics.Since${filter[0].value
              .charAt(0)
              .toUpperCase()}${filter[0].value.slice(1)}`,
          )}
          percentage={tokensStatistics?.data?.percentageAvgConsumptionChange}
          primaryValue={formatNumber(avg / avgDivisor)}
          unit={avgUnit}
          body={`${
            fetchTokensStatisticsRequestState === RequestState.LOADING ||
            fetchTokensStatisticsRequestState === RequestState.SUCCEEDED ||
            fetchTokensStatisticsRequestState == RequestState.UNINITIALIZED
              ? formatNumber(max / maxDivisor)
              : '-'
          } ${maxUnit} ${t('Analytics.MaxConsumption')}`}
          isLoading={fetchTokensStatisticsRequestState === RequestState.LOADING}
          showDash={
            !(
              fetchTokensStatisticsRequestState === RequestState.LOADING ||
              fetchTokensStatisticsRequestState === RequestState.SUCCEEDED ||
              fetchTokensStatisticsRequestState == RequestState.UNINITIALIZED
            )
          }
        />
        <AnalyticsDataCard
          title={t('Analytics.TokensCount')}
          primaryValue={formatNumber(tokensStatistics?.data?.tokensVirtual)}
          secondaryValue={formatNumber(tokensStatistics?.data?.tokensRFID)}
          primaryLabel={t('Analytics.Virtual')}
          secondaryLabel={t('Analytics.Rfid')}
          body={` ${
            fetchTokensStatisticsRequestState === RequestState.LOADING ||
            fetchTokensStatisticsRequestState === RequestState.SUCCEEDED ||
            fetchTokensStatisticsRequestState == RequestState.UNINITIALIZED
              ? formatNumber(tokensStatistics?.data?.totalTokens)
              : '-'
          } ${t('Analytics.Tokens')}`}
          isLoading={fetchTokensStatisticsRequestState === RequestState.LOADING}
          showDash={
            !(
              fetchTokensStatisticsRequestState === RequestState.LOADING ||
              fetchTokensStatisticsRequestState === RequestState.SUCCEEDED ||
              fetchTokensStatisticsRequestState == RequestState.UNINITIALIZED
            )
          }
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  tokensStatistics: AnalyticsSelectors.getTokensStatistics(state),
  fetchTokensStatisticsRequestState:
    AnalyticsSelectors.getFetchTokensStatisticsRequestState(state),
})
function mapDispatchToProps(dispatch) {
  return {
    fetchTokensStatistics: (filter) =>
      dispatch(AnalyticsActions.fetchTokensStatistics(filter)),
  }
}
TokensStatisticsCard.propTypes = {
  tokensStatistics: PropTypes.object,
  fetchTokensStatistics: PropTypes.func,
  fetchTokensStatisticsRequestState: PropTypes.number,
  filter: PropTypes.object,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TokensStatisticsCard)
